import Vue from 'vue'
import router from './router'
import './plugins/vuetify'
import App from './App.vue'
import './stylus/main.styl'
import VueKatex from 'vue-katex'
import 'katex/dist/katex.min.css';

Vue.use(VueKatex)

Vue.config.productionTip = false
var GeoPattern = require('geopattern');
var pattern = GeoPattern.generate('Mastering Markdown', {color: '#ffffff', generator: 'triangles'});
var url = pattern.toDataUrl();
Object.defineProperty(Vue.prototype, '$BackgroundURL', { value: url });

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
